import React, { useState, useRef } from "react";

import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";

import ColorPalettes from "./ColorPalettes";
import { ColorPalettesIcon } from "../icons/ColorPalettes";
import {
  ColorPaletteContainer,
  ColorPalettesButton,
  ColorPalettesColorTile,
} from "./styles";
import { useClickOutside } from "@Shared/Hooks/useClickOutside";
import { useOpticsStore } from "../../../stores/use-optics-store";

const ColorPalettesPicker = () => {
  const [isOpen, setIsOpen] = useState(false);
  const colorPalette = useOpticsStore((state) => state.colorPalette);
  const colorPalettesPickerRef = useRef();
  const { t } = useTranslation();
  const theme = useTheme();

  useClickOutside(colorPalettesPickerRef, () => {
    setIsOpen(false);
  });

  return (
    <ColorPaletteContainer ref={colorPalettesPickerRef}>
      <ColorPalettesButton onClick={() => setIsOpen(!isOpen)}>
        {colorPalette ? t("color-palette") : t("color-palettes")}
        {colorPalette ? (
          <ColorPalettesColorTile
            hasHover={false}
            accentColor={colorPalette.accent[theme.name]}
            textColor={colorPalette.text[theme.name]}
            size={24}
          >
            Aa
          </ColorPalettesColorTile>
        ) : (
          <ColorPalettesIcon />
        )}
      </ColorPalettesButton>

      {isOpen && <ColorPalettes />}
    </ColorPaletteContainer>
  );
};

export default ColorPalettesPicker;
